import PropTypes from 'prop-types'
import React from 'react'
import { connect } from 'react-redux'
import { Form as Base } from 'react-redux-form'
import find from 'lodash/fp/find'

const propTypes = {
  form: PropTypes.shape({
    $form: PropTypes.object.isRequired,
  }).isRequired,
}

const mapStateToProps = (state, { model }) => ({
  form: state[`${model}Form`],
})

function findNestedInvalidForm(fields) {
  const invalidKeys = Object.keys(fields).filter(
    key => fields[key].$form && fields[key].$form.valid === false
  )
  return fields[invalidKeys[0]].$form
}

/**
 * Extends react-redux-form and try to scroll first invalid form element to view
 */
export class Form extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      newSubmit: false,
    }
  }

  componentDidUpdate(prevProps) {
    const { form } = this.props
    const { $form, ...fields } = form
    const { newSubmit } = this.state
    // Change state after form submit button click (intents contains submit for while)
    const newSubmitState = !!find({ type: 'submit' })($form.intents)
    if (prevProps.form.$form.intents !== form.$form.intents && newSubmitState) {
      this.setState({ newSubmit: newSubmitState })
    }

    const notSubmitting = !find({ type: 'submit' })($form.intents)
    // Check if just submitted form
    if ($form.submitFailed && newSubmit && notSubmitting) {
      const field =
        find({ valid: false })(fields) || findNestedInvalidForm(fields)
      const element = document.querySelector(`[name="${field.model}"]`)
      if (element) {
        element.scrollIntoView()
      }
      // Reset submit state or scroll will happen always.
      this.setState({ newSubmit: false })
    }
  }

  render() {
    return <Base {...this.props} />
  }
}

Form.propTypes = propTypes

export default connect(mapStateToProps)(Form)
